import { useCallback, useEffect, useRef, useState } from 'react';

// After a reply is sent, the AI takes about 20 seconds to analyze it.
// start() shows an "analyzing" state and refreshes the page data every 5
// seconds (in case the live update is missed). done() is called when a live
// update arrives. Gives up quietly after 90 seconds. (Move 5)
export default function useAnalyzing(refresh) {
  const [analyzing, setAnalyzing] = useState(false);
  const timer = useRef(null);
  const stopAt = useRef(0);
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  const done = useCallback(() => {
    if (timer.current) { clearInterval(timer.current); timer.current = null; }
    setAnalyzing(false);
  }, []);

  const start = useCallback(() => {
    if (timer.current) clearInterval(timer.current);
    setAnalyzing(true);
    stopAt.current = Date.now() + 90000;
    timer.current = setInterval(() => {
      if (Date.now() > stopAt.current) { done(); return; }
      try { refreshRef.current && refreshRef.current(); } catch { /* ignore */ }
    }, 5000);
  }, [done]);

  useEffect(() => () => { if (timer.current) clearInterval(timer.current); }, []);

  return { analyzing, start, done };
}
